import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/index-page/first-screen-x2.webp")